"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useState = void 0;
const vue_1 = require("vue");
const stateRepository_1 = require("../app/state/stateRepository");
function useState() {
    const isLoading = (0, vue_1.ref)(false);
    const isSuccess = (0, vue_1.ref)(false);
    const isError = (0, vue_1.ref)(false);
    const error = (0, vue_1.ref)("");
    const fetch = async () => {
        try {
            isLoading.value = true;
            const response = await (0, stateRepository_1.findAll)();
            isSuccess.value = true;
            return response;
        }
        catch (e) {
            isError.value = true;
            error.value = e;
        }
        finally {
            isLoading.value = false;
        }
        return null;
    };
    return { isLoading, isSuccess, isError, error, fetch };
}
exports.useState = useState;
